import type { PermissionResource } from '../model/types';
import { PERMISSION_DOMAIN_LABEL_MAP } from '../config/permission-domain-label-map';
import { PERMISSION_RESOURCE_TO_DOMAIN_MAP } from '../config/permission-resource-to-domain-map';

export type PermissionGroup = {
  label: string;
  permissions: string[];
};

export const groupPermissions = (permissions: string[]): PermissionGroup[] => {
  const buckets = new Map<string, string[]>();

  for (const permission of permissions) {
    const [resource = ''] = permission.split(':');
    const domain = PERMISSION_RESOURCE_TO_DOMAIN_MAP[resource as PermissionResource];
    const key = domain ?? resource;

    const existing = buckets.get(key) ?? [];
    buckets.set(key, [...existing, permission]);
  }

  return Array.from(buckets, ([key, groupedPermissions]) => ({
    label:
      PERMISSION_DOMAIN_LABEL_MAP[key as keyof typeof PERMISSION_DOMAIN_LABEL_MAP] ?? key,
    permissions: groupedPermissions,
  }));
};
